export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '调剂确认',
} as TCommon.RouteConfig
